import type { ReactElement } from 'react';
import React from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ButtonProps } from 'reactstrap';
import { Button } from 'reactstrap';

export type IconButtonProps = {
  icon: IconProp;
  text?: string | number | ReactElement;
  textPosition?: 'start' | 'center' | 'end';
  spin?: boolean;
} & ButtonProps;

export default function IconButton({
  icon,
  text = '',
  textPosition = 'center',
  spin,
  children,
  ...buttonProps
}: React.PropsWithChildren<IconButtonProps>): ReactElement {
  return (
    <Button {...buttonProps}>
      <span className={`d-flex align-items-center justify-content-${textPosition}`}>
        {/* We assign a fixed width here to make icon buttons possible to align vertically */}
        <FontAwesomeIcon spin={spin} icon={icon} style={{ width: 30 }} />
        {children || text}
      </span>
    </Button>
  );
}
